"use client";

import React from "react";

/** Whether the element Base UI renders is a native button, which it enhances differently. */
export const rendersNativeButton = (element: React.ReactNode, as?: React.ElementType) => {
  const type = React.isValidElement(element) ? element.type : as;
  if (typeof type === "string") return type === "button";
  return true;
};
